var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('AppHeader',{staticClass:"border--bottom"}),_c('div',{staticClass:"wrapper-content d-flex flex-column"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }